import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { ChatInboxModel } from '@/models'

import { CreateCustomChatInboxRequest } from './create-custom-inbox'

export type UpdateCustomChatInboxRequest = Pick<
  CreateCustomChatInboxRequest,
  'name' | 'memberIds'
> &
  Pick<ChatInboxModel, 'id'>

export const updateCustomChatInbox = async ({ id, ...data }: UpdateCustomChatInboxRequest) => {
  const response = await authAPI.patch<ChatInboxModel>(`/chat-inbox/custom/${id}`, data)
  return response.data
}

export const useUpdateCustomChatInbox = () => {
  return useMutation({
    mutationFn: updateCustomChatInbox,
  })
}
